import { useLocation, BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { ClientAuthProvider } from "./contexts/ClientAuthContext";
import { ProtectedAdminRoute, ProtectedClientRoute } from "./components/ProtectedRoute";
import Home from "./pages/Home";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminPage from "./pages/AdminPage";
import ClientLoginPage from "./pages/ClientLoginPage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import PortalPage from "./pages/PortalPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import "@/App.css";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallbackPage />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin-login" element={<AdminLoginPage />} />
      <Route
        path="/admin"
        element={
          <ProtectedAdminRoute>
            <AdminPage />
          </ProtectedAdminRoute>
        }
      />
      <Route path="/portal-login" element={<ClientLoginPage />} />
      <Route
        path="/portal"
        element={
          <ProtectedClientRoute>
            <PortalPage />
          </ProtectedClientRoute>
        }
      />
      <Route path="/payment/success" element={<PaymentSuccessPage />} />
      <Route path="/payment/cancel" element={<PaymentCancelPage />} />
    </Routes>
  );
}

function App() {
  return (
    <AdminAuthProvider>
      <ClientAuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </ClientAuthProvider>
    </AdminAuthProvider>
  );
}

export default App;
